import React from "react";
let About = () => {
  document.title = "About | Montuli Cafe";
  return <div></div>;
};
export default About;
